module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-33.dbe5c01e.png";